import { render, staticRenderFns } from "./PrivacyModalContent.vue?vue&type=template&id=53597c62&scoped=true"
import script from "./PrivacyModalContent.vue?vue&type=script&lang=js"
export * from "./PrivacyModalContent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyModalContent.vue?vue&type=style&index=0&id=53597c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53597c62",
  null
  
)

export default component.exports